<form>
    <div class="condition-container">
        <h4 class="red-title">{{ groupId }} - {{ conditionType.label }}</h4>

        <div class="inputs-container">
            <!-- Category -->
            <div class="tv-container-select-white-rect-extensible">
                <mat-form-field>
                    <mat-label>Catégorie de la négociation</mat-label>
                    <mat-select panelClass="tv-custom-always-visible-scroll-bar" [formControl]="categoryTypeFormControl">
                        <mat-option *ngFor="let category of categoryTypeList" class="tv-ns-select-option" [value]="category">
                            {{ category.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Search Item -->
            <div class="tv-rect-input-extensible">
                <mat-form-field>
                    <mat-label>Rechercher</mat-label>
                    <input
                        class="tv-ns-select-option"
                        type="text"
                        aria-label="Number"
                        matInput
                        [formControl]="searchFormControl"
                        [matAutocomplete]="auto" />
                    <mat-autocomplete class="tv-custom-always-visible-scroll-bar" #auto="matAutocomplete" [displayWith]="displayItem">
                        <mat-option
                            *ngFor="let item of filteredItemList | async; trackBy: trackByItemId"
                            class="tv-ns-select-option"
                            [value]="item">
                            {{ item.name }} ({{ item.id }})
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <!-- List Button-->
            <button
                type="button"
                [disabled]="isFilteredItemListFill()"
                (click)="listAllOptions()"
                class="tv-round-icon-button-icon-medium-light-blue">
                <mat-spinner *ngIf="isItemLoading; else listIcon" diameter="20" class="light-spinner"></mat-spinner>
                <ng-template #listIcon>
                    <mat-icon>list</mat-icon>
                </ng-template>
            </button>

            <!-- Delete condition button -->
            <button type="button" class="tv-round-icon-button-icon-medium-light-blue" (click)="removeCondition()">
                <mat-icon class="material-icons-outlined">delete</mat-icon>
            </button>
        </div>

        <div>
            <mat-chip-set class="tv-chip-dark-square">
                <mat-chip *ngFor="let chip of chosenItemList" (removed)="removeItem(chip)">
                    {{ getCategoryTypeToDisplay(chip.itemType) }} - {{ chip.item.name }}
                    <button type="button" matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
            </mat-chip-set>
        </div>
    </div>
</form>
